import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ShowSubImageArrownSvg() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.534 15L0.0710001 0.362999H16.976L8.534 15Z"
        fill="#FFFFFF"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default function ShowSubImageArrown(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={ShowSubImageArrownSvg} {...props} />
}
